const readValue = (record, fieldName) => {
  if (!record) return "";
  return record[fieldName] ? String(record[fieldName]).trim() : "";
};

const uniqueValues = (values) => {
  const seen = new Set();
  return values.filter((value) => {
    if (!value || seen.has(value)) return false;
    seen.add(value);
    return true;
  });
};

export const getPlantDisplayParts = (plant, fallbackPlantId = "") => {
  const id = readValue(plant, "plant_id") || String(fallbackPlantId || "").trim();
  const name = readValue(plant, "plant_name") || id || "-";
  const code = readValue(plant, "plant_code");

  return {
    name,
    code,
    id: id && id !== name ? id : "",
  };
};

export const getPlantDropdownLabel = (plant, fallbackPlantId = "") => {
  const { name, code, id } = getPlantDisplayParts(plant, fallbackPlantId);
  const suffix = uniqueValues([code, id]).map((value) => `(${value})`).join(" ");

  return suffix ? `${name} ${suffix}` : name;
};

export const getPlantCompactLabel = (plant, fallbackPlantId = "") => {
  const { name, code, id } = getPlantDisplayParts(plant, fallbackPlantId);
  return uniqueValues([name, code, id]).join(" ") || "-";
};
